import http from 'plugins/axios';
import userInfoHelper from 'common/userInfo';

export default {
  getAnnouncementList(data) {
    return http.post({
      url: '/la/admin/announcement/list',
      data,
      dataType: 'form'
    });
  },
  createAnnouncement(data) {
    return http.post({
      url: '/la/admin/announcement/create',
      data
    });
  },
  updateAnnouncement(data) {
    return http.post({
      url: '/la/admin/announcement/update',
      data
    });
  },
  removeAnnouncement(id) {
    return http.post({
      url: `/la/admin/announcement/remove/${id}`
    });
  },
  publishAnnouncement(id) {
    return http.post({
      url: `/la/admin/announcement/publish/${id}`
    });
  },
  getCategories() {
    return http.get({
      url: '/la/admin/announcement/categories'
    });
  },
  updateCategories(data) {
    return http.post({
      url: '/la/admin/announcement/categories/update',
      data
    });
  }
};
